import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/PersonnelStatistics',
    name: 'PersonnelStatistics',
    component: () => import('../views/personnel-statistics')
  },
  {
    path: '/StatisticsRulePage',
    name: 'StatisticsRulePage',
    component: () => import('../views/description-page/statistics-rule-page.vue')
  },
  {
    path: '/SubscribeRulePage',
    name: 'SubscribeRulePage',
    component: () => import('../views/description-page/subscribe-rule-page.vue')
  },
  {
    path: '/PositioningRulePage',
    name: 'PositioningRulePage',
    component: () => import('../views/description-page/positioning-rule-page.vue')
  },
  {
    path: '/DsbResearcherstrack',
    name: 'DsbResearcherstrack',
    component: () => import('../components/DsbResearcherstrack.vue')
  },
  {
    path: '/dsb-about-us',
    name: 'DsbAboutUs',
    component: () => import('../components/DsbAboutUs.vue')
  },
  {
    path: '/dsb-cancellation',
    name: 'DsbCancellation',
    component: () => import('../components/DsbCancellation.vue')
  },
  {
    path: '/dsb-contactUs',
    name: 'DsbContactUs',
    component: () => import('../components/DsbContactUs.vue')
  },
  {
    path: '/dsb-complaint',
    name: 'DsbComplaint',
    component: () => import('../components/DsbComplaint.vue')
  },
  {
    path: '/dsb-download',
    name: 'DsbDownload',
    component: () => import('../components/DsbDownload.vue')
  },
  {
    path: '/dsb-permission',
    name: 'DsbPermission',
    component: () => import('../components/DsbPermission.vue')
  },
  {
    path: '/dsb-privacy-agreement',
    name: 'DsbPrivacyAgreement',
    component: () => import('../components/DsbPrivacyAgreement.vue')
  },
  {
    path: '/dsb-revoke-msg',
    name: 'DsbRevokeMsg',
    component: () => import('../components/DsbRevokeMsg.vue')
  },
  {
    path: '/dsb-user-agreement',
    name: 'DsbUserAgreement',
    component: () => import('../components/DsbUserAgreement.vue')
  },
  {
    path: '/dsb-problem',
    name: 'DsbProblem',
    component: () => import('../components/DsbProblem.vue')
  },
  {
    path: '/dsb-intelligent-Wages',
    name: 'DsbIntelligentWages',
    component: () => import('../components/DsbIntelligentWages.vue')
  },
  {
    path: '/point-data',
    name: 'pointData',
    component: () => import('../components/pointData.vue')
  },
  {
    path: '/customer_details',
    name: 'CustomerDetails',
    component: () => import(/* webpackChunkName: "CustomerDetails" */ '../views/CustomerDetails.vue')
  },
  {
    path: '/customer_details_old',
    name: 'CustomerDetailsOld',
    component: () => import(/* webpackChunkName: "CustomerDetailsOld" */ '../views/CustomerDetailsOld.vue')
  },
  {
    path: '/add_visit_records',
    name: 'AddVisitRecords',
    component: () => import(/* webpackChunkName: "AddVisitRecords" */ '../views/AddVisitRecords.vue')
  },
  {
    path: '/mortgage_calculator',
    name: 'MortgageCalculator',
    component: () => import(/* webpackChunkName: "MortgageCalculator" */ '../views/MortgageCalculator.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/calc_result',
    name: 'CalcResult',
    component: () => import(/* webpackChunkName: "CalcResult" */ '../views/CalcResult.vue')
  },
  {
    path: '/housing_details',
    name: 'HousingDetails',
    component: () => import(/* webpackChunkName: "HousingDetails" */ '../views/HousingDetails.vue')
  },
  {
    path: '/housing_overview',
    name: 'HousingOverview',
    component: () => import(/* webpackChunkName: "HousingOverview" */ '../views/HousingOverview.vue')
  },
  {
    path: '/house_type_list',
    name: 'HouseTypeList',
    component: () => import(/* webpackChunkName: "HouseTypeList" */ '../views/HouseTypeList.vue')
  },
  {
    path: '/housing_dynamic',
    name: 'HousingDynamic',
    component: () => import(/* webpackChunkName: "HousingDynamic" */ '../views/HousingDynamic.vue')
  },
  {
    path: '/fall',
    name: 'Fall',
    component: () => import(/* webpackChunkName: "Fall" */ '../views/Fall.vue')
  }
]
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js